import WideSecureLayout from "../../layout/WideSecureLayout.jsx";
import {useTranslation} from "react-i18next";
import {useContext, useEffect, useRef, useState} from "react";
import ProjectUser from "./ProjectUser.jsx";
import Pagination from "../../components/Pagination.jsx";
import useDownloadState from "../../api/utilities/useDownloadState.js";
import {useSearchParams} from "react-router-dom";
import LoadingComponent from "../../components/LoadingComponent.jsx";
import {GlobalContext} from "../../utils/context/GlobalContextProvider.jsx";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {fas} from "@fortawesome/free-solid-svg-icons";
import {ProjectApi, ProjectPermission} from "../../api/authority/generated/index.ts";
import FormError from "../../components/form/FormError.jsx";
import ProjectInvitationButton from "./ProjectInvitationButton.jsx";
import toast from "react-hot-toast";
import {useErrorTranslation} from "../../api/utilities/translateErrorMessage.js";
import {useHasPermission} from "../../components/auth/rolesAndPermissions.js";
import Button from "../../components/Button.jsx";

export default function ProjectUsers({project}) {
    let {t} = useTranslation();
    let {et} = useErrorTranslation();

    let hasPermission = useHasPermission();

    let [searchQuery, setSearchQuery] = useState('');
    let searchInput = useRef('');

    let {getAuthorityConfiguration} = useContext(GlobalContext);

    let [state, setDownloading, setResult, setError] = useDownloadState();

    let [searchParams, setSearchParams] = useSearchParams();

    let page = parseInt(searchParams.get('page') ?? 1);


    useEffect(() => {
        setDownloading(true);
        new ProjectApi(getAuthorityConfiguration())
            .projectUsers({
                page: page,
                projectId: project.id,
                searchTerm: searchInput.current,
            })
            .then(r => setResult(r))
            .catch(e => setError(e))
            .finally(() => setDownloading(false));
    }, [project.id, page, searchQuery]);

    const [projectRoles, setProjectRoles] = useState([]);

    useEffect(() => {
        new ProjectApi(getAuthorityConfiguration())
            .projectRoles({
                projectId: project.id,
            })
            .then(r => setProjectRoles(r))
            .catch((e) => et(e).then(toast.error));
    }, [project.id]);

    return (
        <WideSecureLayout title={t('route.project-users')} actions={
            hasPermission(ProjectPermission.ProjectInvitations, project) &&
            <ProjectInvitationButton project={project}/>
        }>
            <LoadingComponent loading={state.downloading}>
                <section className={'flex flex-col gap-4'}>
                    <div className={'flex align gap-2'}>
                        <label htmlFor="search-users" className="sr-only">
                            {t('search-call-to-action')}
                        </label>
                        <input
                            id="search-users"
                            className="comp__roundedControl group form-input w-full bg-white dark:bg-slate-800"
                            type="search"
                            placeholder={t('searching') + '…'}
                            onChange={e => searchInput.current = e.target.value}
                        />
                        <Button
                            aria-label={t('search-call-to-action')}
                            onClick={() => setSearchQuery(searchInput.current)}
                        >
                            <FontAwesomeIcon icon={fas.faMagnifyingGlass} className={'px-2'}/>
                        </Button>
                    </div>

                    <div
                        className="comp__roundedBox py-1 bg-white dark:bg-slate-800 rounded-sm border border-slate-200 dark:border-slate-700">
                        <div className="bg-none overflow-x-auto">

                            {state.error && <FormError error={state.error}/>}

                            {state.result &&
                                <div
                                    className="comp__userList table-auto w-full dark:text-slate-300 divide-y divide-slate-200 dark:divide-slate-700"
                                >
                                    {state.result.data.map((projectUserOutput) => {
                                        return (<ProjectUser
                                            key={projectUserOutput.user.id}
                                            project={project}
                                            projectUser={projectUserOutput}
                                            projectRoles={projectRoles}
                                        />);
                                    })}
                                </div>
                            }
                        </div>
                    </div>

                    <Pagination
                        pagination={state.result?.pagination}
                        onPageChange={(page) => setSearchParams({page: page})}
                    />

                </section>
            </LoadingComponent>
        </WideSecureLayout>
    );
}
